<template>
    <div class="y-chat-window">
        <chat-message-item
            v-for="message in messages"
            :key="message.id"
            :message="message"
            @editMessage="editMessage($event)"
            :class="{'is_me': message.from == student.id}"
        />
    </div>
</template>


<script>
import ChatMessageItem from './ChatMessageItemComponent'

export default {
    name: "ChatMessageComponent",
    components: { ChatMessageItem },
    props: {
        messages: {
            type: Array,
            required: true
        },
        student: ''
    },
    data() {
        return {
            show_new_input: false,
            new_message: '',
        }
    },

    methods: {
        editMessage(event) {
            this.$emit('editMessage', {
                message_id: event.message_id,
                message: event.message,
            })
        },
    }
}
</script>
